/* 🤖 this file was generated by svg-to-ts */
export var spxIconAuditLog = {
    name: 'audit_log',
    data: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" aria-hidden=\"true\"><path d=\"M12 2a10 10 0 1 0 10 10h-2a8 8 0 1 1-2.343-5.657L15 9h6V3l-2.101 2.101A9.973 9.973 0 0 0 12 2Zm-1 5v6l4.243 2.53.997-1.671L13 12.286V7h-2Z\"/></svg>"
};
